import AppButton from '@/app/(webapp)/_components/ui/app-button';
import { IconShoppingCart } from '@/app/(webapp)/_components/ui/icons';
import { useCart } from '@/app/(webapp)/_contexts/cart-context';
import { useSelectedLayoutSegments } from 'next/navigation';

interface CartButtonProps {
    isScrolled?: boolean;
    className?: string;
    isMobile?: boolean;
}

export default function CartButton({ isScrolled, className, isMobile }: CartButtonProps) {
    const { cartItemsCount } = useCart();

    const segments = useSelectedLayoutSegments();

    return (
        <AppButton
            href="/cart"
            customClassName={`relative ${className} ${segments[0] === 'cart' ? 'bg-overlay-white-30 hover:bg-overlay-white-30' : isScrolled ? `${!isMobile ? 'bg-overlay-white-10 hover:bg-overlay-white-25' : ''}` : `${!isMobile ? 'bg-overlay-white-10  hover:bg-overlay-white-15' : ''}`}`}
        >
            {cartItemsCount > 0 && (
                <div className="absolute top-0 left-0 transform -translate-x-1/2 -translate-y-1/2 leading-none font-medium text-[12px] rounded-[4px] bg-brand-primary-hover text-content-on-dark p-[4px]">
                    {cartItemsCount}
                </div>
            )}
            <IconShoppingCart />
        </AppButton>
    );
}
